import { WidgetViewModel } from './WidgetViewModel';
import { EditorDOMUtils } from 'Editor/services/_Common/DOM';
import { TooltipWidgetView } from '../../Views';

export class TooltipWidgetModel extends WidgetViewModel<'tooltip'> {
  constructor(
    Visualizer: Editor.Visualizer.State,
    refView: Editor.Visualizer.WidgetDataMapper['tooltip']['view'],
    props: Editor.Visualizer.WidgetDataMapper['tooltip']['props'],
  ) {
    super(Visualizer, refView, props);

    this.container.style.pointerEvents = 'none';
    this.container.dataset.type = 'tooltip';
  }

  render() {
    const offsets = EditorDOMUtils.getOffsets(this.refView);

    if (!offsets) {
      return;
    }

    const isFieldInMultiline = this.getRefView().getClientRects().length > 1;
    let sectionWidth = 0;
    const isPageLayout = this.Visualizer.getLayoutType?.() === 'PAGE';
    let widgetPosition: Rect | undefined;

    if (isPageLayout) {
      this.container.style.left = 'calc(50%)';
      const widgetContainer = this.Visualizer.getWidgetsManager?.();
      if (!widgetContainer) {
        return;
      } else {
        widgetPosition = widgetContainer.widgetsDOMContainer.getBoundingClientRect();
      }
    }

    if (isFieldInMultiline) {
      const parentNode = EditorDOMUtils.closestBlockTextElement(this.refView);

      if (parentNode) {
        if (isPageLayout) {
          sectionWidth = EditorDOMUtils.convertUnitTo(
            this.Visualizer.dataManager?.sections.getPageWidthForBlockId(parentNode.id),
            'pt',
            'px',
          );
        } else {
          sectionWidth = EditorDOMUtils.convertUnitTo(
            this.Visualizer.dataManager?.sections.getPageWidthForBlockId(parentNode.id, 'WEB'),
            'pt',
            'px',
          );
        }
      }
    }
    this.renderReactComponent(
      <TooltipWidgetView
        {...this.props}
        offsets={offsets}
        isFieldInMultiline={isFieldInMultiline}
        isPageLayout={isPageLayout}
        widgetPositionRect={widgetPosition}
        sectionWidth={sectionWidth}
      />,
    );
  }
}
